
import { LeaderboardEntry } from '@/types'
import { UserAvatar } from '@/components/Avatar'

interface LeaderboardItemProps {
  entry: LeaderboardEntry
  rank: number
  type: 'today' | 'total'
}

const LeaderboardItem: React.FC<LeaderboardItemProps> = ({ entry, rank, type }) => {
  const getRankIcon = (rank: number) => {
    switch (rank) {
      case 1:
        return <div className="w-8 h-8 flex items-center justify-center bg-yellow-100 rounded-full"><span className="text-lg font-bold text-yellow-600">🏆</span></div>
      case 2:
        return <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-full"><span className="text-lg font-bold text-gray-600">🥈</span></div>
      case 3:
        return <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-full"><span className="text-lg font-bold text-amber-600">🥉</span></div>
      default:
        return <div className="w-8 h-8 flex items-center justify-center bg-gray-50 rounded-full"><span className="text-sm font-bold text-gray-500">{rank}</span></div>
    }
  }





  return (
    <div className="p-2 hover:bg-white/50 transition-colors">
      {/* 使用Table布局确保html2canvas对齐 */}
      <div
        style={{
          display: 'table',
          width: '100%',
          tableLayout: 'fixed',
          padding: '8px 4px'
        }}
      >
        {/* 排名图标 */}
        <div
          style={{
            display: 'table-cell',
            width: '56px',
            textAlign: 'center',
            verticalAlign: 'middle'
          }}
        >
          {getRankIcon(rank)}
        </div>

        {/* 头像 */}
        <div
          style={{
            display: 'table-cell',
            width: '64px',
            textAlign: 'center',
            verticalAlign: 'middle'
          }}
        >
          <UserAvatar
            src={entry.user.avatar}
            username={entry.user.username}
            userId={entry.user.id}
            size="lg"
            className="rounded-xl"
            lazy={true}
            priority={rank <= 3} // 前三名优先加载
          />
        </div>

        {/* 用户名 - 特殊调整中文对齐 */}
        <div
          style={{
            display: 'table-cell',
            textAlign: 'left',
            verticalAlign: 'middle',
            paddingLeft: '8px',
            paddingRight: '8px'
          }}
        >
          <span
            className="username-text"
            style={{
              fontFamily: 'Arial, sans-serif',
              fontSize: '20px',
              fontWeight: '500',
              color: '#111827',
              lineHeight: '24px',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          >
            {entry.user.username}
          </span>
        </div>

        {/* 分数区域 - Table cell确保对齐 */}
        <div
          style={{
            display: 'table-cell',
            width: '80px',
            textAlign: 'right',
            verticalAlign: 'middle'
          }}
        >
          {type === 'today' ? (
            <span
              style={{
                fontFamily: 'Arial, sans-serif',
                fontSize: '30px',
                fontWeight: 'bold',
                color: type === 'today' ? '#2563eb' : '#d97706',
                lineHeight: '24px',
                display: 'inline-block',
                verticalAlign: 'middle'
              }}
            >
              {entry.todayCount}
            </span>
          ) : (
            <div style={{ textAlign: 'right' }}>
              <div
                style={{
                  fontFamily: 'Arial, sans-serif',
                  fontSize: '30px',
                  fontWeight: 'bold',
                  color: '#d97706',
                  lineHeight: '24px',
                  display: 'inline-block',
                  verticalAlign: 'middle'
                }}
              >
                {entry.totalCount}
              </div>
              <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>
                7日均 {entry.weeklyAverage}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default LeaderboardItem
